import { render } from "./DynamicHtmlHr.vue?vue&type=template&id=0ddff68c&ts=true"
import script from "./DynamicHtmlHr.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlHr.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlHr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ddff68c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ddff68c', __exports__)) {
    api.reload('0ddff68c', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlHr.vue?vue&type=template&id=0ddff68c&ts=true", () => {
    api.rerender('0ddff68c', render)
  })

}


export default __exports__